import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Stagger, StaggerItem } from "@/components/Reveal";
import Countdown from "@/components/Countdown";
import { getWithRetry } from "@/lib/api";
import { IMAGES } from "@/lib/content";

function fmt(d) {
  return new Date(d).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", timeZone: "America/New_York" });
}

export default function BuyTickets() {
  const [events, setEvents] = useState([]);
  useEffect(() => { getWithRetry("/events?status=upcoming").then((r) => setEvents(r.data)).catch(() => setEvents([])); }, []);

  return (
    <>
      <Seo title="Reserve Events & Bottle Service in Washington DC" description="Reserve your spot at ChiCha Lounge DC events — free entry RSVP and $50 bottle service deposits. Book ahead for Howard Homecoming week. Instant email confirmation." path="/buy-tickets" image={IMAGES.crowd} />
      <PageHero badge="Get In" title="Reserve" subtitle="Free entry RSVP and $50 bottle service deposits — reserve ahead and we'll email your confirmation." />

      <section className="pb-28">
        <div className="max-w-[1100px] mx-auto px-5 md:px-8">
          {events.length === 0 ? (
            <p className="text-neutral-400 py-20 text-center">No events on sale right now. Check back soon.</p>
          ) : (
            <Stagger className="space-y-5">
              {events.map((ev, i) => {
                const tiers = (ev.tiers || []).filter((t) => t.name !== "Archived");
                const hasFree = tiers.some((t) => Number(t.price) === 0);
                const hasVip = tiers.some((t) => t.price > 0);
                return (
                  <StaggerItem key={ev.id}>
                    <Link to={`/events/${ev.slug}`} data-testid={`ticket-event-${ev.slug}`} className="card-lux overflow-hidden grid md:grid-cols-[300px_1fr] group">
                      <div className="relative h-56 md:h-auto overflow-hidden">
                        <img src={ev.flyer_image} alt={ev.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      </div>
                      <div className="p-7 flex flex-col justify-center">
                        <h3 className="display-mega text-3xl">{ev.title}</h3>
                        <p className="text-neutral-500 text-sm mt-1">{fmt(ev.date)} · {ev.start_time}</p>
                        <div className="flex flex-wrap gap-2 mt-4">
                          {hasFree && <span className="pill-badge">Free entry · RSVP</span>}
                          {hasVip && <span className="pill-badge">$50 bottle deposit</span>}
                        </div>
                        {i === 0 && <div className="mt-4"><Countdown date={ev.date} /></div>}
                        <span data-testid={`buy-${ev.slug}`} className="btn-gold mt-6 self-start">Reserve <ArrowRight size={16} /></span>
                      </div>
                    </Link>
                  </StaggerItem>
                );
              })}
            </Stagger>
          )}
        </div>
      </section>
    </>
  );
}
